module.exports = __webpack_public_path__ + "assets/img/1_1729.d100f6bf.jpg";